import React from "react";
import { LuDownload } from "react-icons/lu";
import { css } from "glamor";
import { Page, Spinner, spacing } from "../library";
import DownloadsCourseMenuContainer from "./DownloadsCourseMenuContainer";
import DownloadsCourseSectionsContainer from "./DownloadsCourseSectionsContainer";

const containerClass = css({
  minHeight: "100%",
  "@media (min-width: 768px)": {
    display: "flex",
    gap: spacing.m,
  },
});

export default function Downloads({
  loading,
}) {
  if (loading) return <Spinner text="Carregando central de downloads..." />;

  return (
    <Page title="Central de downloads" icon={LuDownload}>
      <div className={containerClass}>
        <DownloadsCourseMenuContainer />
        <DownloadsCourseSectionsContainer />
      </div>
    </Page>
  );
}
